import { render } from "./DangerZone.vue?vue&type=template&id=0a3ba21b"
import script from "./DangerZone.vue?vue&type=script&lang=js"
export * from "./DangerZone.vue?vue&type=script&lang=js"
script.render = render

export default script